import Flx from "../../../components/layout/Flx";
import Txt from "../../../components/typography/Txt";

const DashboardSection = ({
  children,
  label,
  mt = 3.5,
  sx = {},
  labelSx = {},
}) => {
  return (
    <Flx column fw gap={1} sx={{ mt: mt, ...sx }}>
      <Txt sx={{ fontSize: "14.6px", ...labelSx }} secondary>
        {/* <Txt sx={{ fontSize: "15.2px" }} secondary> */}
        {label}
      </Txt>

      {children}
    </Flx>
  );
};

export default DashboardSection;
